module.exports = __webpack_public_path__ + "img/f5.c02279ca.jpg";